<template>
	<div class="pb-5">
		<template v-if="$route.name === 'working-environment-surveys'">
			<surveys-list :tool-code="toolCode" />
		</template>
		<template v-else>
			<router-view></router-view>
		</template>
	</div>
</template>

<script>
import surveysList from '@/components/surveys/surveys-list';
import toolsCodes from '@/shared/tools-codes';

const { WorkingEnvironment } = toolsCodes;

function data() {
	return {
		toolCode: WorkingEnvironment,
	};
}

export default {
	name: 'page-surveys-list',
	components: {
		surveysList,
	},
	data,
};
</script>



// WEBPACK FOOTER //
// src/pages/working-environment/page-surveys.vue